// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1442":"8773381c0502049d","8515":"c405f3937b651a91"}[chunkId] + ".css";
};